<template>
  <AppDialog
    v-model="isDialogOpen"
    header="Get Test Access Link"
    style="width: 35rem"
    @click:close="handleClose"
  >
    <AppStepperSimple
      v-model="stepIndex"
      :steps="['setup', 'link']"
      class="flex flex-col gap-4"
    >
      <template #step-1>
        <div class="flex flex-col gap-6">
          <AppDrawerFormField
            label="Candidate Loading Strategy"
            description="Select how the candidate's data will be loaded"
          >
            <AppInputDropdown
              v-model="candidateStrategy"
              :options="candidateStrategyOptions"
            />
          </AppDrawerFormField>

          <!-- <AppDrawerFormField
            label="Connection Mode"
            description="Select how the test submission will be linked to an assessment (optional)"
          >
            <AppInputDropdown
              v-model="connectionMode"
              :options="connectionModeOptions"
              :disabled="assessmentOptions.length === 0"
            />
          </AppDrawerFormField> -->

          <!-- <template v-if="connectionMode === 'assessment'">
            <AppDrawerFormField
              label="Assessment Connections"
              description="Select which assessments the test submission will be linked to"
            >
              <AppInputMultiSelect
                v-model="connectedAssessmentIds"
                :options="assessmentOptions"
                placeholder="Select one or more assessments"
                option-value="id"
                option-label="title"
              />
            </AppDrawerFormField>
          </template> -->
        </div>
      </template>

      <template #step-2>
        <span class="text-xs text-surface-700"
          >The test can be accessed from the link below</span
        >
        <AppInputText
          v-model="testLink"
          :append-icon="copyIcon"
          :is-append-icon-button="true"
          readonly
          @click-append-icon="handleClickCopy"
        />
      </template>
    </AppStepperSimple>
    <template #actions>
      <div class="flex justify-between items-center gap-4 w-full">
        <AppButtonTextSecondary
          label="Close"
          @click="handleConfirm"
        />
        <div class="flex justify-end items-center gap-4">
          <AppButton
            v-if="stepIndex > 0"
            variant="outline"
            label="Back"
            @click="stepIndex--"
          />
          <AppButton
            v-if="stepIndex < 1"
            variant="primary"
            label="Next"
            @click="nextStep"
          />
        </div>
      </div>
    </template>
  </AppDialog>
</template>

<script setup lang="ts">
// import { useAssessmentStore } from '@/stores/assessment'
import { useWorkspaceStore } from '@/stores/workspace'
import getFullClientPath from '@/utils/getFullClientPath'
import { TestFormat } from '~/types/Test'

// const assessmentStore = useAssessmentStore()
const workspaceStore = useWorkspaceStore()

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  testId: {
    type: String,
    required: true,
  },
  testFormat: {
    type: String as PropType<TestFormat>,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue', 'resolve', 'close'])

const isDialogOpen = computed({
  get() {
    return props.modelValue
  },
  set(value: boolean) {
    emit('update:modelValue', value)
  },
})

// const connectedAssessmentIds = ref<string[]>([])

const queryParams = computed(() => {
  const output: Record<string, string | string[]> = {}

  if (candidateStrategy.value === 'promptCandidate') {
    output.manual_candidate = 'true'

    if (workspaceStore.currentWorkspace) {
      output.organization = `ws:${workspaceStore.currentWorkspace.id}`
    }
  }

  if (candidateStrategy.value === 'demo') {
    output.demo = 'true'
  }

  // if (connectionMode.value === 'assessment') {
  //   output.a = connectedAssessmentIds.value
  // }

  return output
})

const testLink = useUrlBuilder(
  getFullClientPath(
    `${props.testFormat === TestFormat.Submission ? 'submission' : 'test'}/${props.testId}`,
  ),
  queryParams,
)

function handleClose() {
  emit('close')
  isDialogOpen.value = false
}

function handleConfirm() {
  emit('resolve')
  isDialogOpen.value = false
}

const candidateStrategy = ref<'iframe' | 'promptCandidate' | 'demo'>(
  'promptCandidate',
)

const candidateStrategyOptions = [
  { label: 'Prompt Candidate', value: 'promptCandidate' },
  { label: 'Iframe', value: 'iframe' },
  { label: 'Demo', value: 'demo' },
]

// const connectionMode = ref<'assessment' | 'none'>('none')

// const assessmentOptions = computed(() => {
//   if (assessmentStore.$isInitialising) return []

//   return assessmentStore.getAssessmentsByTestId(props.testId)
// })

const stepIndex = ref(0)

function nextStep() {
  stepIndex.value++
}

// COPY LINK ================================================================================================
const copyIcon = ref('fa-regular fa-clone')

async function handleClickCopy() {
  await navigator.clipboard.writeText(testLink.value)
  copyIcon.value = 'fa-regular fa-check'

  setTimeout(() => {
    copyIcon.value = 'fa-regular fa-clone'
  }, 3000)
}
</script>
